import { DialogTitle, Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";

function SendReminder() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    let name = "Roy";

    const studentArray = [
        {
            name: "Abinayan Ratnasingam Abinayan Abinayan Abinayan",
            lastActivity: "18/12/2024"
        },
        {
            name: "Abinayan2",
            lastActivity: "18/12/2024"
        },
        {
            name: "Abinayan3",
            lastActivity: "20/12/2024"
        },
        {
            name: "Abinayan4",
            lastActivity: "21/12/2024"
        },
    ]

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };


    return (
        <>
            <div className={`${i18n.language==="en"?"font-urban":(i18n.language==="si"?"font-noto":"font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[20px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">Send reminder</p>
                    </div>
                </div>

                <div className="grid grid-cols-3 mt-[10px] bg-[#FDC50C] py-[10px] mx-[20px] md:mx-[100px] lg:mx-[130px] rounded-t-xl">
                    <div className="text-black text-[14px] flex justify-center font-bold">
                        <p>Student name</p>
                    </div>
                    <div className="text-black text-[14px] flex justify-center font-bold">
                        <p>Last active</p>
                    </div>
                    <div className="text-black text-[14px] flex justify-center font-bold">
                        <p>Action</p>
                    </div>
                </div>
                <div className="bg-[#FFF4CE] rounded-b-xl mx-[20px] md:mx-[100px] lg:mx-[130px]">
                    {studentArray.length > 0 ?
                        studentArray.map((student, index) => (
                            <>
                                <div key={index} className="md:hidden grid grid-cols-3 py-[10px] items-center">
                                    <div className="text-black text-[13px] flex justify-center ">
                                        <p>{student.name.length > 15
                                            ? `${student.name.slice(0, 15)}...`
                                            : student.name}</p>
                                    </div>
                                    <div className="text-black text-[13px] flex justify-center ">
                                        <p>{student.lastActivity}</p>
                                    </div>
                                    <div className="text-black text-[14px] flex justify-center font-bold">
                                        <button className="bg-[#FFBEA3] text-[#AF3D39] text-[13px] rounded-lg py-[3px] w-[100px]">Remind</button>
                                    </div>
                                </div>
                                <div key={index} className="hidden md:grid lg:hidden grid-cols-3 py-[10px] items-center">
                                    <div className="text-black text-[15px] flex justify-center ">
                                        <p>{student.name.length > 23
                                            ? `${student.name.slice(0, 23)}...`
                                            : student.name}</p>
                                    </div>
                                    <div className="text-black text-[15px] flex justify-center ">
                                        <p>{student.lastActivity}</p>
                                    </div>
                                    <div className="text-black text-[14px] flex justify-center font-bold">
                                        <button className="bg-[#FFBEA3] text-[#AF3D39] text-[13px] rounded-lg py-[3px] w-[100px]">Remind</button>
                                    </div>
                                </div>
                                <div key={index} className="hidden lg:grid xl:hidden grid-cols-3 py-[10px] items-center">
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.name.length > 28
                                            ? `${student.name.slice(0, 28)}...`
                                            : student.name}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.lastActivity}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center font-bold">
                                        <button className="bg-[#FFBEA3] text-[#AF3D39] text-[13px] rounded-lg py-[3px] w-[100px]">Remind</button>
                                    </div>
                                </div>
                                <div key={index} className="hidden xl:grid 2xl:hidden grid-cols-3 py-[10px] items-center">
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.name.length > 35
                                            ? `${student.name.slice(0, 35)}...`
                                            : student.name}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.lastActivity}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center font-bold">
                                        <button className="bg-[#FFBEA3] text-[#AF3D39] text-[13px] rounded-lg py-[3px] w-[100px]">Remind</button>
                                    </div>
                                </div>
                                <div key={index} className="hidden 2xl:grid grid-cols-3 py-[10px] items-center">
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.name.length > 45
                                            ? `${student.name.slice(0, 45)}...`
                                            : student.name}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center ">
                                        <p>{student.lastActivity}</p>
                                    </div>
                                    <div className="text-black text-[16px] flex justify-center font-bold">
                                        <button className="bg-[#FFBEA3] text-[#AF3D39] text-[13px] rounded-lg py-[3px] w-[100px]">Remind</button>
                                    </div>
                                </div>
                            </>
                        )) :
                        <div className="flex justify-center py-[10px] xl:py-[20px] text-[15px] xl:text-[17px]">
                            <p>All reminders are sent</p>
                        </div>
                    }
                </div>

            </div>
            <Dialog
                open={open2}
                onClose={handleClose}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>Invitation sent succesfully</div>
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    Close
                                </Button>
                            </div>
                        </DialogContent>
                    }

                    {
                        isLoading &&
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <Commet color="#FDC50C" size="medium" text="" textColor="" />
                        </DialogContentText>
                    }

                </DialogContent>
            </Dialog>
        </>
    )
}

export default SendReminder;
